import Header from "@/components/feature/Header";
import Footer from "@/components/feature/Footer";
import Breadcrumb from "@/components/feature/Breadcrumb";
import SEOHead from "@/components/feature/SEOHead";

export default function AboutPage() {
  const pageTitle = "关于芒果视频 - 品牌介绍 | 西瓜视频小蓝视频的同类替代选择";
  const pageDescription = "芒果视频品牌介绍：作为西瓜视频、小蓝视频的同类替代选择，我们提供免费高清在线观看服务。了解芒果视频的品牌故事、用户口碑和联系方式。";
  const pageKeywords = "芒果视频,关于芒果视频,芒果视频品牌,免费高清在线观看,西瓜视频替代,小蓝视频同类";

  const schemaData = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "AboutPage",
        name: pageTitle,
        description: pageDescription,
        url: "https://mangguoshipin.com/about",
        isPartOf: {
          "@type": "WebSite",
          name: "芒果视频",
          url: "https://mangguoshipin.com",
        },
      },
      {
        "@type": "Organization",
        name: "芒果视频",
        url: "https://mangguoshipin.com",
        description: "芒果视频作为西瓜视频、小蓝视频的同类替代选择，提供免费高清在线观看服务。",
        foundingDate: "2020",
        contactPoint: {
          "@type": "ContactPoint",
          telephone: "400-888-6666",
          contactType: "customer service",
          availableLanguage: "Chinese",
        },
        address: {
          "@type": "PostalAddress",
          addressLocality: "长沙",
          addressRegion: "湖南",
          addressCountry: "CN",
          streetAddress: "岳麓区芒果视频大厦",
        },
      },
      {
        "@type": "FAQPage",
        mainEntity: [
          {
            "@type": "Question",
            name: "芒果视频和西瓜视频有什么区别？",
            acceptedAnswer: {
              "@type": "Answer",
              text: "芒果视频作为西瓜视频的同类替代选择，在画质表现和播放流畅度上更具优势。芒果视频支持4K超清画质，采用智能CDN加速技术，确保高清不缓冲的观看体验。同时资源库更加丰富，更新速度更快。",
            },
          },
          {
            "@type": "Question",
            name: "芒果视频是否需要付费？",
            acceptedAnswer: {
              "@type": "Answer",
              text: "芒果视频提供完全免费的在线观看服务，无需付费即可享受高清画质。我们通过极简广告策略维持运营，不会影响您的观影体验。",
            },
          },
          {
            "@type": "Question",
            name: "芒果视频支持哪些设备？",
            acceptedAnswer: {
              "@type": "Answer",
              text: "芒果视频支持全平台观看，包括网站、iOS、Android手机App、平板电脑以及智能电视投屏。您可以在任何设备上享受一致的优质观影体验。",
            },
          },
          {
            "@type": "Question",
            name: "芒果视频的资源更新频率如何？",
            acceptedAnswer: {
              "@type": "Answer",
              text: "芒果视频每日更新超过500部新内容，涵盖电影、电视剧、综艺、动漫、纪录片等全品类。热门剧集和综艺节目会在播出后第一时间上线，让您追剧不等待。",
            },
          },
          {
            "@type": "Question",
            name: "芒果视频和茄子视频、丝瓜视频相比有什么优势？",
            acceptedAnswer: {
              "@type": "Answer",
              text: "与茄子视频、丝瓜视频等平台相比，芒果视频在多个方面具有明显优势：画质更清晰（支持4K超清）、播放更流畅（智能CDN加速）、资源更全面（10万+影视资源库）、界面更简洁（极简广告策略）。芒果视频是同类平台中的最佳替代选择。",
            },
          },
          {
            "@type": "Question",
            name: "芒果视频为什么比小蓝视频更流畅不缓冲？",
            acceptedAnswer: {
              "@type": "Answer",
              text: "芒果视频在全国部署了超过200个CDN加速节点，配合自适应码率技术和高效视频编码技术，能够根据您的网络状况自动调整画质，确保在任何网络环境下都能流畅播放。这是芒果视频相比小蓝视频实现不缓冲体验的核心技术优势。",
            },
          },
        ],
      },
      {
        "@type": "BreadcrumbList",
        itemListElement: [
          {
            "@type": "ListItem",
            position: 1,
            name: "首页",
            item: "https://mangguoshipin.com",
          },
          {
            "@type": "ListItem",
            position: 2,
            name: "关于我们",
          },
        ],
      },
    ],
  };

  return (
    <div className="min-h-screen bg-white">
      <SEOHead
        title={pageTitle}
        description={pageDescription}
        keywords={pageKeywords}
        canonicalUrl="https://mangguoshipin.com/about"
        schemaData={schemaData}
      />
      <Header />
      <main className="pt-16">
        <div className="bg-gray-50/80">
          <div className="max-w-4xl mx-auto px-4 md:px-6 py-6 md:py-8">
            <Breadcrumb
              items={[
                { label: "首页", href: "/" },
                { label: "关于我们" },
              ]}
            />
            <h1 className="text-2xl md:text-3xl font-bold text-gray-900">
              关于芒果视频
            </h1>
          </div>
        </div>

        <section className="max-w-4xl mx-auto px-4 md:px-6 py-12 md:py-16">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12 items-center mb-16">
            <div>
              <h2 className="text-xl md:text-2xl font-bold text-gray-900 mb-4">
                品牌故事
              </h2>
              <div className="space-y-4 text-sm md:text-base text-gray-600 leading-relaxed">
                <p>
                  芒果视频创立于2020年，总部位于中国长沙。作为<strong>西瓜视频和小蓝视频的同类替代选择</strong>，芒果视频始终致力于为用户提供<strong>免费高清在线观看</strong>服务。
                </p>
                <p>
                  在类似<strong>茄子视频、丝瓜视频</strong>等众多免费视频平台中，芒果视频以其卓越的播放体验和丰富的资源库脱颖而出，成为越来越多用户的<strong>芒果视频替代首选</strong>。
                </p>
                <p>
                  我们的使命是让每一个人都能享受到高品质的视频内容。通过持续的技术创新和内容投入，芒果视频已经发展成为拥有超过500万活跃用户的领先视频平台。
                </p>
              </div>
            </div>
            <div className="rounded-xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20creative%20office%20space%20with%20warm%20amber%20and%20golden%20accent%20lighting%2C%20team%20collaboration%20atmosphere%2C%20minimalist%20interior%20design%20with%20wooden%20elements%2C%20professional%20yet%20cozy%20environment%2C%20natural%20light%20streaming%20through%20windows%2C%20high%20detail%2C%20warm%20inviting%20composition&width=600&height=400&seq=about-brand&orientation=landscape"
                alt="芒果视频品牌故事"
                className="w-full h-full object-cover"
                title="芒果视频品牌故事"
              />
            </div>
          </div>

          <div className="mb-16">
            <h2 className="text-xl md:text-2xl font-bold text-gray-900 mb-8 text-center">
              为什么选择芒果视频
            </h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
              {[
                {
                  icon: "ri-4k-line",
                  title: "超清画质",
                  desc: "支持4K超清画质播放，画面细腻逼真，色彩还原度高，给你影院级视觉享受。",
                },
                {
                  icon: "ri-speed-up-line",
                  title: "流畅不缓冲",
                  desc: "智能CDN加速网络，自适应码率技术，确保在任何网络条件下流畅播放。",
                },
                {
                  icon: "ri-database-2-line",
                  title: "海量资源",
                  desc: "超过10万部影视资源，涵盖电影、电视剧、综艺等全品类，每日更新500+。",
                },
                {
                  icon: "ri-shield-check-line",
                  title: "安全可靠",
                  desc: "正规运营，注重用户隐私保护，极简广告策略不影响观影体验。",
                },
              ].map((item) => (
                <div
                  key={item.title}
                  className="bg-white rounded-xl border border-gray-100 p-6 text-center hover:border-amber-200 transition-colors"
                >
                  <div className="w-12 h-12 mx-auto mb-4 flex items-center justify-center bg-amber-50 rounded-xl">
                    <i className={`${item.icon} text-2xl text-amber-500`}></i>
                  </div>
                  <h3 className="text-base font-semibold text-gray-900 mb-2">
                    {item.title}
                  </h3>
                  <p className="text-xs text-gray-500 leading-relaxed">
                    {item.desc}
                  </p>
                </div>
              ))}
            </div>
          </div>

          <div className="mb-16">
            <h2 className="text-xl md:text-2xl font-bold text-gray-900 mb-8 text-center">
              用户口碑
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
              {[
                {
                  name: "王先生",
                  role: "资深影迷",
                  avatar: "https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20Chinese%20man%20in%20casual%20attire%2C%20warm%20friendly%20expression%2C%20soft%20studio%20lighting%2C%20clean%20background%2C%20professional%20headshot%20style%2C%20neutral%20warm%20tones&width=80&height=80&seq=avatar-1&orientation=squarish",
                  text: "用了芒果视频之后，真的再也回不去了。画质比茄子视频好太多，而且基本不缓冲，看电影终于不用等半天了！强烈推荐给所有喜欢看视频的朋友。",
                  rating: 5,
                },
                {
                  name: "李女士",
                  role: "追剧达人",
                  avatar: "https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20Chinese%20woman%20with%20warm%20smile%2C%20modern%20casual%20look%2C%20soft%20natural%20lighting%2C%20clean%20warm%20background%2C%20professional%20headshot%2C%20friendly%20approachable%20expression&width=80&height=80&seq=avatar-2&orientation=squarish",
                  text: "以前用西瓜视频和小蓝视频追剧，更新总是慢半拍。换了芒果视频之后，热门剧集更新速度明显更快，而且画质更清晰，追剧体验提升了一大截！",
                  rating: 5,
                },
                {
                  name: "张同学",
                  role: "动漫爱好者",
                  avatar: "https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20young%20Chinese%20student%2C%20casual%20stylish%20look%2C%20warm%20natural%20expression%2C%20soft%20studio%20lighting%2C%20clean%20background%2C%20modern%20headshot%20style%2C%20friendly%20vibe&width=80&height=80&seq=avatar-3&orientation=squarish",
                  text: "芒果视频的动漫频道太全了！日漫国漫都有，更新的速度不输丝瓜视频。关键是画质很稳定，看番体验一级棒。已经推荐给全班同学了！",
                  rating: 5,
                },
              ].map((testimonial) => (
                <div
                  key={testimonial.name}
                  className="bg-white rounded-xl border border-gray-100 p-6"
                >
                  <div className="flex items-center gap-3 mb-4">
                    <img
                      src={testimonial.avatar}
                      alt={testimonial.name}
                      className="w-11 h-11 rounded-full object-cover"
                    />
                    <div>
                      <p className="text-sm font-semibold text-gray-900">
                        {testimonial.name}
                      </p>
                      <p className="text-xs text-gray-400">
                        {testimonial.role}
                      </p>
                    </div>
                  </div>
                  <p className="text-sm text-gray-600 leading-relaxed mb-3">
                    {testimonial.text}
                  </p>
                  <div className="flex items-center gap-0.5">
                    {Array.from({ length: testimonial.rating }).map((_, i) => (
                      <i
                        key={i}
                        className="ri-star-fill text-amber-400 text-sm"
                      ></i>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-12">
            <div>
              <h2 className="text-xl md:text-2xl font-bold text-gray-900 mb-6">
                联系我们
              </h2>
              <div className="space-y-4">
                <div className="flex items-start gap-3">
                  <div className="w-10 h-10 flex items-center justify-center bg-amber-50 rounded-lg shrink-0">
                    <i className="ri-map-pin-line text-amber-500"></i>
                  </div>
                  <div>
                    <p className="text-sm font-medium text-gray-900">公司地址</p>
                    <p className="text-sm text-gray-500">
                      湖南省长沙市岳麓区芒果视频大厦
                    </p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-10 h-10 flex items-center justify-center bg-amber-50 rounded-lg shrink-0">
                    <i className="ri-phone-line text-amber-500"></i>
                  </div>
                  <div>
                    <p className="text-sm font-medium text-gray-900">客服电话</p>
                    <p className="text-sm text-gray-500">400-888-6666</p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-10 h-10 flex items-center justify-center bg-amber-50 rounded-lg shrink-0">
                    <i className="ri-mail-line text-amber-500"></i>
                  </div>
                  <div>
                    <p className="text-sm font-medium text-gray-900">电子邮箱</p>
                    <p className="text-sm text-gray-500">
                      contact@mangguoshipin.com
                    </p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-10 h-10 flex items-center justify-center bg-amber-50 rounded-lg shrink-0">
                    <i className="ri-time-line text-amber-500"></i>
                  </div>
                  <div>
                    <p className="text-sm font-medium text-gray-900">工作时间</p>
                    <p className="text-sm text-gray-500">
                      周一至周日 9:00 - 22:00
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="rounded-xl overflow-hidden h-64 md:h-80">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d68733.5243006816!2d112.92410217910156!3d28.227635000000004!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x34215e3c6f3e1e2b%3A0x5a7d3f3e1e2b3c4d!2z6ZW_5rKZ5biC5bKz5bG15Yy6!5e0!3m2!1szh-CN!2scn!4v1690000000000!5m2!1szh-CN!2scn"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="芒果视频公司位置"
                aria-label="芒果视频公司位置地图"
              ></iframe>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}